import callModal from './callModal.html'
import recordingPlayer from './recordingPlayer.html'
import computerMode from './computerMode.html'
import phoneMode from './phoneMode.html'
import callEnded from './callEnded.html'
import callEndedRecording from './callEndedRecording.html'
import callEndedPlayer from './callEndedPlayer.html'
import recordingProcessing from './recordingProcessing.html'
import recordingUnavailable from './recordingUnavailable.html'

export {
  callModal,
  recordingPlayer,
  computerMode,
  phoneMode,
  callEnded,
  callEndedRecording,
  callEndedPlayer,
  recordingProcessing,
  recordingUnavailable
}
